<template>
  <v-dialog max-width="800" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined color="primary"
        >detalle<v-icon>details</v-icon></v-btn
      >
    </template>

    <v-card
      id="liquidacionResumen"
      v-if="liquidacionResumen.length > 0"
      class="pa-1"
    >
      <v-card-text>
        <h1 class="title">{{ op.generacion.descripcion }}</h1>
        <v-divider></v-divider>
        <h1 class="subtitle-1">
          {{
            op.liquidacion.autor.nombres + " " + op.liquidacion.autor.apellidos
          }}
        </h1>
        <v-divider></v-divider>
        <v-container class="my-5">
          <v-card class="pa-3" flat>
            <v-layout row wrap>
              <v-flex class="xs12 ms4 md3">
                <div class="caption grey--text">Monto</div>
                <div class="font-weight-bold">
                  {{ op.monto | numberFormat }}
                </div>
              </v-flex>
              <v-flex class="xs12 ms4 md3">
                <div class="caption grey--text">Pago</div>
                <div>
                  <ul v-if="op.pagosDetalle && op.pagosDetalle.some(p => p.estado !== 'Anulado')">
                    <li v-for="pago in op.pagosDetalle" :key="pago.id">
                      <div v-if="pago.pago.estado == 'Cerrado'">
                        {{ pago.monto | numberFormat }}
                        {{ pago.pago.medioPago.nombre }}
                        {{ pago.pago.fechaApertura | dateFormat }}
                      </div>
                      <div v-else>
                        En proceso {{ pago.pago.medioPago.nombre }}
                      </div>
                    </li>
                  </ul>
                </div>
              </v-flex>
              <v-flex class="xs6 ms4 md3">
                <div class="caption grey--text">Saldo</div>
                <div class="">{{ saldoOP(op) | numberFormat }}</div>
              </v-flex>
              <v-flex class="xs6 ms6 md2">
                <div class="caption grey--text">Estado</div>
                <div v-if="op.estado == 'Valido'">
                  <v-icon class="green--text">check_circle</v-icon>
                  <!-- <div v-if="op.pagosDetalle.length > 0">Pagado</div> -->
                  <div v-if="op.pagosDetalle && op.pagosDetalle.some(p => p.estado !== 'Anulado')">Pagado</div>
                  <div v-else>Pendiente</div>
                </div>
                <div v-if="op.estado != 'Valido'" class="red--text">
                  <v-icon class="red--text">error_outline</v-icon>
                  {{ op.estado }}
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-container>

        <v-divider></v-divider>

        <v-container class="my-5" v-if="!loading">
          <v-card class="pa-3" flat>
            <v-layout>
              <v-flex class="xs12 ms6 md6">
                <div class="caption grey--text text-left">Asignacion</div>
              </v-flex>
              <v-flex class="xs12 ms6 md6 text-right">
                <div class="caption grey--text">Monto</div>
              </v-flex>
            </v-layout>
            <v-layout
              row
              v-for="liq in liquidacionResumen"
              :key="liq.asignacion"
            >
              <v-flex class="xs12 ms6 md6">
                <div class="text-left">{{ liq.asignacion }}</div>
              </v-flex>
              <v-flex class="xs12 ms6 md6">
                <div class="text-right">{{ liq.monto | numberFormat }}</div>
              </v-flex>
              <v-divider></v-divider>
            </v-layout>
            <v-layout>
              <v-flex class="xs12 ms6 md6 text-right">
                <div class="text-left red lighten-3">
                  TOTAL (ingresos - descuentos)
                </div>
              </v-flex>
              <v-flex class="xs12 ms6 md6 text-right">
                <div class="text-right red lighten-3 font-weight-bold">
                  {{ total | numberFormat }}
                </div>
              </v-flex>
            </v-layout>
            <!-- <ChartTopRadio :liquidacionId="this.liquidacion_id"/> -->
            <ChartTopObrasRadio :liquidacionId="this.liquidacion_id" />
            <ChartTopObrasTv :liquidacionId="this.liquidacion_id" />
            <!-- <ChartTopTv :liquidacionId="this.liquidacion_id" /> -->
          </v-card>
        </v-container>
        <v-divider></v-divider>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-container class="my-5">
          <v-layout row wrap>
            <v-flex xs3 md3>
              <Confirmar
                boton=""
                titulo="Descargar"
                texto="¿Te gustaría descargar el detalle en formato PDF?"
                icon="save_alt"
                small
                :loading="downloading"
                @si="descargar()"
              />
            </v-flex>
            <v-flex xs3 md3>
              <Confirmar
                boton=""
                titulo="Enviar"
                :texto="`¿Te gustaría recibir una copia por correo electrónico?`"
                icon="email"
                small
                :loading="sendingMail"
                @si="enviarCorreo"
              />
            </v-flex>
            <v-flex xs6 md6>
              <v-btn color="primary" outlined @click="volver()">Volver</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-actions>
    </v-card>
    <div class="red-text">{{ errorMessage }}</div>
  </v-dialog>
</template>

<script>
import numeral from "numeral";
import axios from "axios";
import Confirmar from "@/components/Confirmar";
import ChartTopObrasRadio from "@/components/regalias/ChartTopObrasRadio.vue";
import ChartTopObrasTv from "@/components/regalias/ChartTopObrasTv.vue";
import { saveAs } from "file-saver";
import format from "date-fns/format";

export default {
  props: ["liquidacion_id", "op"],
  data() {
    return {
      showDialog: false,
      liquidacionResumen: [],
      sendingMail: false,
      downloading: false,
      loading: false,
      errorMessage: "",
    };
  },
  mounted() {
    this.loading = true;
    axios
      .get("/autor/0/liquidacion/" + this.liquidacion_id)
      .then((response) => {
        this.loading = false;
        this.liquidacionResumen = response.data;
      })
      .catch((err) => {
        console.log(err);
        this.loading = false;
        window.alert("error " + err);
        this.errorMessage = "Error en la consulta";
      });
  },
  methods: {
    descargar() {
      this.downloading = true;
      axios
        .get("/report/liquidacion/" + this.liquidacion_id)
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
          this.downloading = false;
          this.$store.dispatch("showSnack", "Descargando..!");
        })
        .catch((err) => {
          this.downloading = false;
          console.log(err);
          this.errorMessage = "Error en la consulta";
          this.$store.dispatch("showSnack", "Error");
        });
    },
    descargarResumen() {
      this.downloading = true;
      axios
        .get("/report/ordenpago/resumen/" + this.op.id)
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
          this.downloading = false;
          this.$store.dispatch("showSnack", "Descargando..!");
        })
        .catch((err) => {
          this.downloading = false;
          console.log(err);
          this.errorMessage = "Error en la consulta";
          this.$store.dispatch("showSnack", "Error");
        });
    },

    async enviarCorreo() {
      this.sendingMail = true;

      try {
        let usuario = await axios
          .get("/miapa/miusuario")
          .then((response) => response.data);
        axios
          .get(
            `/email/liquidacion?id= ${this.liquidacion_id}&to=${usuario.email}`
          )
          .then(() => {
            this.sendingMail = false;
            this.$store.dispatch("showSnack", "Correo enviado!");
          });
          
      } catch(err) {
            this.sendingMail = false;
            console.log(err);
            this.$store.dispatch("showSnack", "Error!");
      }
    },
    volver() {
      this.showDialog = false;
    },
    saldoOP(op) {
      return op.monto - op.pagosDetalle.reduce((a, b) => a + b.monto, 0);
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
  },
  filters: {
    // numberToHHMM(value) {
    //   if (value) {
    //     return value ? format(new Date(value), "hh:mm") : "";
    //   }
    // },
    numberFormat(value) {
      if (value) {
        return numeral(value).format("#,##0"); // displaying other groupings/separators is possible, look at the docs
      }
    },
    dateFormat(value) {
      return value ? format(new Date(value), "dd/MM/YYY") : "";
    },
  },
  computed: {
    total() {
      return this.liquidacionResumen.reduce((a, b) => +a + b.monto, 0);
    },
    username() {
      return this.$store.getters.user.username
        ? this.$store.getters.user.username
        : "algo no anda";
    },
  },
  components: {
    Confirmar,
    ChartTopObrasRadio,
    ChartTopObrasTv,
  },
};
</script>

<style scoped>
#chip.Valido {
  background: lightgreen;
}

#chip.Anulado {
  background: lightcoral;
}

#chip.Retenido {
  background: lightcoral;
}

#chip.Reservado {
  background: lightcoral;
}
</style>
